import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'countryAbbreviation',
    standalone: false
})
export class CountryAbbreviationPipe implements PipeTransform {
    transform(country: string) {
        switch (country?.toUpperCase()) {
            case 'CANADA':
            case 'CAN': return 'CA';
            case 'UNITED STATES':
            case 'UNITED STATES OF AMERICA': 
            case 'THE UNITED STATES OF AMERICA': 
            case 'UNITED STATES OF AMERICA (THE)': 
            case "LES ÉTATS-UNIS":
            case "ÉTATS-UNIS D’AMÉRIQUE":
            case "ETATS-UNIS D'AMERIQUE": 
            case "USA": 
            case "U.S.A.": return 'US';
            default: return ''; 
        }
    }
}